// @material-ui/core components
import { makeStyles } from "tss-react/mui";

// core components
import Image from "next/image.js";

// local assets
import loader from "../../public/img/forums/loader.png";

import styles from "../../styles/jss/nextjs-material-kit/pages/forumsStyle.js";

const useStyles = makeStyles()(styles);

export default function ForumsLoader(props) {
    const { classes, cx } = useStyles();
    return (
        <div className={cx(classes.spinnerContainer + " " + classes.container)}>
            <Image className={classes.spinner} src={loader} alt={"loading-spinner"} width={150} height={150} />
        </div>
    )
}

